module.exports = __webpack_public_path__ + "static/media/plus_small.dede24ef.svg";